<template lang="pug">
    .intro_background
        .container(ref="container")

</template>

<script>
    import * as THREE from 'three/src/Three';
    export default {
        name: "IntroBackground",
        data:()=>({
            camera:null,
            scene:null,
            renderer:null,


            mouseX:0,
            mouseY:0,

            halfX:0,
            halfY:0,

            radius: 300,

            particles:[],

            infos:[],
        }),
        methods:{
            init(){
                this.halfX = window.innerWidth/2;
                this.halfY = window.innerHeight/2;


                this.scene = new THREE.Scene();

                this.renderer = new THREE.WebGLRenderer({alpha: true});

                this.renderer.setPixelRatio(window.devicePixelRatio);
                this.renderer.setSize(window.innerWidth, window.innerWidth);

                this.$refs.container.appendChild(this.renderer.domElement);
                this.camera = new THREE.PerspectiveCamera(
                    70,
                    window.innerWidth / window.innerHeight,
                    0.001, 5000
                );
                this.camera.position.set( 0, 0, 1500 );


                let material = new THREE.SpriteMaterial({
                    map: new THREE.CanvasTexture(this.getCanvas())
                });


                this.particles = new THREE.Group();
                this.scene.add(this.particles);

                for (let i = 0; i < 500; i++) {
                    let particle = new THREE.Sprite(material);
                    let x = (2*Math.random() - 1)*window.innerWidth;
                    let y = (2*Math.random() - 1)*window.innerWidth;
                    while(Math.sqrt(Math.abs(x)**2 + Math.abs(y)**2) <= this.radius*1.5){
                        x = (2*Math.random() - 1)*window.innerWidth;
                        y = (2*Math.random() - 1)*window.innerWidth;
                    }
                    particle.position.x = x;
                    particle.position.y = y;


                    particle.position.z = (2*Math.random() - 1)*1000;
                    //particle.position.z = 1
                    particle.scale.x = particle.scale.y = 5 + 5*Math.random();

                    this.particles.add(particle);
                }



                this.resize();
                this.infos = Array.prototype.slice.call(document.querySelectorAll('.info'), 0)
            },
            getCanvas() {
                let canvas = document.createElement('canvas');
                canvas.width = 32;
                canvas.height = 32;

                let ctx = canvas.getContext('2d');
                let gradient = ctx.createRadialGradient(16, 16, 0, 16, 16, 16);
                gradient.addColorStop(0.3, 'rgba(54,201,242,0.8)');
                gradient.addColorStop(0.6, 'rgba(54,201,242,1)');
                gradient.addColorStop(1, 'rgba(255,255,255,1)');

                ctx.fillStyle = gradient;
                ctx.fillRect(0,0,32,32);

                return canvas;
            },
            resize() {
                var w = window.innerWidth;
                var h = window.innerHeight;
                this.renderer.setSize( w, h );
                this.camera.aspect = w / h;
                this.camera.updateProjectionMatrix();
            },
            onMouseMove() {
                this.mouseX = event.clientX - this.halfX;
                this.mouseY = event.clientY - this.halfY;
            },

            animate() {


                this.particles.rotation.x += (-this.mouseY/10000 - this.particles.rotation.x)*0.03;
                this.particles.rotation.y += (-this.mouseX /10000 - this.particles.rotation.y)*0.015;
                this.particles.rotation.z += -0.0002;



                // this.particles.rotation.z += -0.0002;
                // this.camera.position.x += (this.mouseX/3 - this.camera.position.x)*0.005;
                // this.camera.position.y += (-this.mouseY/3 - this.camera.position.y)*0.005;

                //camera.position.x += (mouseX/7 - camera.position.x)*0.02;
                //camera.position.y += (-mouseY/7 - camera.position.y)*0.02;
                this.infos.forEach(el=>{
                    el.style.transform = `translate(${-1 * this.mouseX/this.halfX*5}px, ${-1 * this.mouseY/this.halfY*5}px)`
                });

                requestAnimationFrame(this.animate);
                this.render();
            },
            render() {
                this.renderer.render(this.scene, this.camera);
            },
        },
        mounted() {
            window.addEventListener('resize', this.resize);

            document.addEventListener('mousemove', this.onMouseMove);

             this.init();
             this.animate();
        }
    }
</script>

<style scoped lang="scss">
    .intro_background{
        position: absolute;
        top: 0;
        max-height: 100vh;
        overflow: hidden;
        background: #fff;
    }
</style>
